import _ from "lodash"
import moment from "moment"

export const getMockData = () => {
  return {
    ReservationStatus: "open",
    ReservationNumber: "RESNO",
    ReservationConfirmed: true,
    ConfirmationNumber: "CONFNUMBER",
    RateClass: "H",
    RateImageURL: "https://images.hertz.com/vehicles/220x128/ZEAUCDAR999.jpg",
    RateTitle: "COMPACT",
    RateAcriss: "CDAR",
    PackageName: "Test Package Name",
    Options: null,
    ClaimNumber: "CLAIMNUMBER123",
    PolicyNumber: "POLICYNUBER123",
    StaffId: "",
    VoucherClass: "H",
    VoucherImageURL: "https://images.hertz.com/vehicles/220x128/ZEAUCDAR999.jpg",
    VoucherTitle: "COMPACT",
    VoucherAcriss: "CDAR",
    DesiredOptions: "",
    SourceCode: "",
    MainNote: "",
    Notes: [],
    DobOfYoungestDriver: "1999-05-31",
    RentalDuration: 1,
    Pickup: {
      DateTime: "2020-06-12T14:00",
      Month: "June",
      Day: "12",
      Year: "2020",
      Time: "14:00",
      locationName: "MELBOURNE DT",
      locationCode: "MEL60",
      address1: "114 FLINDERS ST",
      address2: "",
      address3: "",
      city: "MELBOURNE, VIC",
      state: "VI",
      postCode: "3000",
      phone: "0396500245",
      latitude: -37.81619,
      longitude: 144.970864,
      franchiseType: "LCP",
      locationType: "LDT",
      commercial: true,
    },
    DropOff: {
      DateTime: "2020-06-13T14:00",
      Month: "June",
      Day: "13",
      Year: "2020",
      locationName: "MELBOURNE DT",
      locationCode: "MEL60",
      address1: "114 FLINDERS ST",
      address2: "",
      address3: "",
      city: "MELBOURNE, VIC",
      state: "VI",
      postCode: "3000",
      phone: "0396500245",
      latitude: -37.81619,
      longitude: 144.970864,
      franchiseType: "LCP",
      locationType: "LDT",
      commercial: true,
    },
    Renter: {
      Title: "MR.",
      FirstName: "FIRSTNAME",
      LastName: "LASTNAME",
      LicenseNumber: "DU123456789",
      LicenseExpiry: "2030-01-24",
      LicenseIssuer: "NZ",
      Street: "STREET ADDRESS",
      StateOrProvCode: "VI",
      PostalCode: "3000",
      CountryCode: "AU",
      City: "MELBOURNE, VIC",
      Email: "EMAIL@DOMAIN.COM",
      HomeTelephoneNumber: "+(64)123456789",
      CellTelephoneNumber: "+(64)123456789",
    },
    AdditionalDriverNotes: {
      FirstName: "",
      LastName: "",
      Phone: "",
      Mobile: "",
    }
  }
}

export const transformSchema = (data, context) => {
  _.merge(data, data.Insurance)
  _.merge(data, {
    Pickup: context.locations.filter((l) => l.locationCode == data.Pickup?.Location?.locationCode)[0],
    DropOff: context.locations.filter((l) => l.locationCode == data.DropOff?.Location?.locationCode)[0],
    VoucherClass: data.VoucherRate?.Class,
  })

  _.merge(data.Renter, {
    LicenseNumber: data.Renter?.DrivingLicense?.Number,
    LicenseExpiry: data.Renter?.DrivingLicense?.ExpiryDate,
    LicenseIssuer: data.Renter?.DrivingLicense?.Issuer,
  })
  _.merge(data.Renter, data.Renter?.Address)
  _.merge(data.Billing, data.Billing?.Customer)

  delete data.Success
  delete data.ReferenceId
  delete data.Renter?.Address
  delete data.Renter?.DrivingLicense
  delete data.Insurance
  delete data.Billing?.Customer
  delete data.Billing?.Voucher
  delete data.Pickup.Location
  delete data.DropOff.Location
  delete data.VoucherRate
  const pickUpDate = moment(data.Pickup.DateTime)
  const dropOffDate = moment(data.DropOff.DateTime)
  data.RentalDuration = moment.duration(dropOffDate.diff(pickUpDate)).days()
  

  return data
}
